import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { endOfYear, startOfYear } from 'date-fns';
import { LocalizedDateFormatPipe } from '@wilson/localization';
import { NumberFormatterPipe } from '@wilson/pipes';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { TimelineVacationBalanceService } from '../../../services/timeline-vacation-balance.service';

@Component({
  selector: 'wilson-vacation-balance-value',
  imports: [
    CommonModule,
    TranslateModule,
    NumberFormatterPipe,
    NzSkeletonModule,
    NzTooltipModule,
  ],
  templateUrl: './vacation-balance-value.component.html',
  styleUrls: ['./vacation-balance-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VacationBalanceValueComponent {
  private readonly localizedDateFormat = inject(LocalizedDateFormatPipe);
  protected readonly vacationBalance = inject(TimelineVacationBalanceService);

  readonly userId = input.required<string>();
  protected readonly yearStart = this.localizedDateFormat.toFormattedSignal(
    startOfYear(new Date()),
  );
  protected readonly yearEnd = this.localizedDateFormat.toFormattedSignal(
    endOfYear(new Date()),
  );
}
